import styled from "@emotion/styled"
import "swiper/css"
import { Swiper, SwiperSlide } from "swiper/react"
import { Desktop, Mobile } from "ui"
import QuarterlyReports from "./QuarterlyReport"

const StyledContainer = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    display: grid;
    grid-template-columns: repeat(4, 4fr);
  }
`

function FinancialQuarter({
  data,
  visible,
  locale,
  index
}: {
  data: any
  visible: boolean
  locale: string
  index: number
}) {
  if (!visible) {
    return null
  }
  const array = [
    data.quarterly01,
    data.quarterly02,
    data.quarterly03,
    data.quarterly04,
  ]
  return (
    <>
      <Desktop>
        <StyledContainer id={String(index + 1)}>
          {array.map((el: any, i: number) => (
            <QuarterlyReports
              key={i}
              el={el}
              index={i}
              locale={locale}
              year={data.year}
            />
          ))}
        </StyledContainer>
      </Desktop>
      <Mobile>
        <Swiper slidesPerView={1.1} width={278} id={String(index + 1)}>
          {array.map((el: any, i: number) => (
            <SwiperSlide key={i}>
              <QuarterlyReports
                key={i}
                el={el}
                index={i}
                locale={locale}
                year={data.year}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Mobile>
    </>
  )
}

export default FinancialQuarter
